// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  API_ENV: 'dev',
  API_HOST: 'https://survey.kodev.io/api/dev',
//   API_HOST: 'http://localhost:4000/',
  APP_VERSION: '1.0.13',
  YEAR:'2026',
//   production: true,
//   API_ENV: 'prod',
//   API_HOST: 'https://survey.kodev.io/api/dev',
//   APP_VERSION: '1.0.13',
//   YEAR:'2020',
  NAME:'Kodev - Surbery'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
